import { PublicKey } from "@solana/web3.js";
import { getCoordinator } from "@crunchdao/sdk";
import { BaseCommand } from "@crunchdao/shared-cli";

export class GetCommand extends BaseCommand {
  async execute(owner?: string): Promise<void> {
    try {
      const ownerAddress = owner ? owner : this.provider.wallet.publicKey.toBase58();
      const coordinator = await getCoordinator(this.program, new PublicKey(ownerAddress));
      this.output(coordinator);
    } catch (error) {
      this.handleError(error);
    }
  }
}
